import React from 'react';
import type { WalletDTO } from '@push.io/shared';
import type { MenuLanguage } from '../main-menu/types.js';

export function WalletDisplay({ wallet, language }: { wallet: WalletDTO | null; language: MenuLanguage }) {
  const tr = (es: string, en: string, fr: string) =>
    language === 'es' ? es : language === 'fr' ? fr : en;
  return (
    <div className="wallet-chip" aria-label={`${tr('Monedas', 'Coins', 'Pièces')}: ${wallet?.softCurrency ?? 0}`}>
      <i aria-hidden="true" />
      <span>{tr('Monedas', 'Coins', 'Pièces')}: {wallet?.softCurrency ?? 0}</span>
    </div>
  );
}
